import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import {ToastType} from '../toast';
import template from './index.jade';
import css from './index.styl?inline';

const DEFAULT_TOAST_TTL = 7000;

// unique ID for every toast added
let toastID = 1;

interface ToastAreaState {
  toasts: Toast[];
}

export interface Toast {
  message: string;
  type?: ToastType;
  id?: number;
  cta?: string;
  ctaCallback?: () => void;
  closeToastCallback?: () => void;
  hide?: boolean;
  'is-error'?: boolean;
  undoable?: boolean;
  undoCallback?: () => void;
  timeout?: number;
}

export class ToastArea extends Component<ToastAreaState> {
  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        toasts: [],
      },
      helpers: {
        toastAction: (toast: Toast) => {
          this.closeToast(toast);
          toast.ctaCallback(); // TODO: this component should dispatch an event instead of accepting callbacks
        },
        toastClose: (toast: Toast) => {
          this.closeToast(toast);
          if (toast.closeToastCallback) {
            toast.closeToastCallback(); // TODO: this component should dispatch an event instead of accepting callbacks
          }
        },
        toastUndo: (toast: Toast) => {
          this.closeToast(toast);
          toast.undoCallback(); // TODO: this component should dispatch an event instead of accepting callbacks
        },
      },
    };
  }

  public addToast(toastAttrs: Toast): Toast {
    const newToast = {
      id: toastID++,
      ttl: DEFAULT_TOAST_TTL,
      type: ToastType.INFO,
      ...toastAttrs,
    };

    if (newToast.cta && !newToast.ctaCallback) {
      console.error(newToast);
      throw new Error(`Invalid toast: must supply ctaCallback with cta`);
    }

    if (newToast.undoable && !newToast.undoCallback) {
      console.error(newToast);
      throw new Error(`Invalid toast: must supply undoCallback if undoable is enabled`);
    }

    this.update({toasts: [...this.state.toasts, newToast]});
    if (newToast.ttl) {
      newToast.timeout = window.setTimeout(() => this.closeToast(newToast), newToast.ttl);
    }

    return newToast;
  }

  public closeToast(toast: Toast) {
    clearTimeout(toast.timeout);
    this.update({toasts: this.state.toasts.map((t) => (t.id === toast.id ? Object.assign(t, {hide: true}) : t))});
  }
}

export default registerMPElement(`mp-toast-area`, ToastArea);
